$(function () {
  $('.slider').slick({
    infinite: true,
    dots: true,
    arrows: false,
    adaptiveHeight: true,
  });
});
